import { useCallback } from "react";

export function useVideoElement(playerId: string) {
    return useCallback(
        () => document.querySelector<HTMLVideoElement>(`#${playerId} video`),
        [playerId]
    );
}

export function enterNativeFullscreen(video: HTMLVideoElement | null) {
    if (!video) return;
    if (video.requestFullscreen) {
        video.requestFullscreen().catch(() => {});
        // @ts-expect-error used on ios
    } else if (video.webkitEnterFullScreen) {
        // @ts-expect-error used on ios
        video.webkitEnterFullScreen();
    }
}
